import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { Leg } from '../../types/strategy-entities';

import { initialState, StrategyLegState } from './state';

const strategyLegSlice = createSlice({
  name: 'strategy-leg',
  initialState,
  reducers: {
    reset: () => initialState,
    loading: (state: StrategyLegState, action: PayloadAction<boolean>) => {
      state.error = undefined;
      state.loading = action.payload;
      state.loaded = !action.payload;
      state.pending = false;
    },
    pending: (state: StrategyLegState, action: PayloadAction<boolean>) => {
      state.error = undefined;
      state.pending = action.payload;
    },
    success: (state: StrategyLegState, action: PayloadAction<Leg[]>) => {
      state.error = undefined;
      state.loading = false;
      state.loaded = true;
      state.legs = action.payload;
    },
    fail: (state: StrategyLegState, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
      state.loaded = true;
      state.legs = [];
    },
    add: (state: StrategyLegState, action: PayloadAction<Leg>) => {
      state.legs.push(action.payload);
      state.loading = false;
      state.loaded = true;
    },
    update: (state: StrategyLegState, action: PayloadAction<Leg>) => {
      const dbEntry = state.legs.find((x) => x.id === action.payload.id);
      if (!!dbEntry) {
        const index = state.legs.indexOf(dbEntry);
        state.legs[index] = action.payload;
      }
      state.pending = false;
    },
    remove: (state: StrategyLegState, action: PayloadAction<Leg>) => {
      const entry = state.legs.find((x) => x.id === action.payload.id);
      const index = entry ? state.legs.indexOf(entry) : -1;
      if (index !== -1) {
        state.legs.splice(index, 1);
      }
      state.loading = false;
      state.loaded = true;
    },
    updateSelectedLeg: (state: StrategyLegState, action: PayloadAction<{ strategyId: string; selectedLegId: string | undefined }>) => {
      state.ui[action.payload.strategyId] = action.payload.selectedLegId;
    }
  }
});

const { actions, reducer } = strategyLegSlice;
export const { reset, loading, pending, success, fail, add, update, remove, updateSelectedLeg } = actions;
export default reducer;
